import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Action } from 'src/app/core/models/action.model';
import { UserService } from 'src/app/core/services/user.service';
import { KycDataService } from '../../services/kyc-data.service';

@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
})
export class KycComponent implements OnInit {
  @Input() action!: Action;

  @Output() completed = new EventEmitter();

  loaded = false;

  constructor(
    private userService: UserService,
    private kycService: KycDataService
  ) {}

  ngOnInit(): void {
    this.buildComponent();
  }

  async buildComponent() {
    const uid = (await this.userService.getCurrentUser())?.id;

    if (!this.action) {
      throw new Error('No requirement loaded');
    }

    if (!uid) {
      throw new Error('No user logged in');
    }

    this.kycService.setData({
      bucket: 'client-documents',
      name: 'kyc.png',
      multiple: false,
      ref: uid,
      type: 'PERSONAL',
      provider: this.action.config.provider,
      isComponentView: true,
    });
    this.loaded = true;
  }

  onComplete() {
    this.completed.next(true);
  }
}
